function areItemsEqual(obj1, obj2) {
    const keys = [
        'cardId', 'condition', 'foil', 'active', 'offerType', 'quantity', 'price',
        'collectionName', 'notes', 'cardName', 'setCode', 'typeLine',
        'rarity', 'language'
    ];

    return keys.every(key => obj1[key] === obj2[key]);
}


export function groupCollectionItems(list) {
    const groups = [];

    list.forEach(item => {
        let foundGroup = false;

        for (let group of groups) {
            if (areItemsEqual(item, group.items[0])) {
                group.items.push(item);
                group.count++;
                foundGroup = true;
                break;
            }
        }

        if (!foundGroup) {
            groups.push({items: [item], count: 1});
        }
    });

    return groups;
}


export const grouper = (items, grouped) => {
    if (grouped) {
        return groupCollectionItems(items)
    } else {
        return items.map(i => {
            return {
                items: [i],
                count: 1
            }
        })
    }
}
